import { combineReducers } from '@reduxjs/toolkit';
import reviews from './reviewsSlice';
import cycles from './cyclesSlice';

const reducer = combineReducers({
  reviews,
  cycles,
});

export default reducer;